import {
  INIT_USER_LIST_REQUEST,
  SET_USER_LIST,
  ERROR_USER_LIST,
  INIT_USER_REQUEST,
  SET_USER,
  ADD_USER,
  ERROR_USER_REQUEST
} from './action';

const initialState = {
  data: [],
  error: null,
  isLoading: false,
  selectedUser: null,
};

const userListReducer = (state = initialState, action) => {
  switch (action.type) {
    case INIT_USER_LIST_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case SET_USER_LIST:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
        error: null,
      };

    case ADD_USER:
      return {
        ...state,
        isLoading: false,
        error: null,
      };

    case ERROR_USER_LIST:
      return {
        ...state,
        data: [],
        isLoading: false,
        error: action.payload,
      };

    case INIT_USER_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
        selectedUser: null,
      };

    case SET_USER:
      return {
        ...state,
        isLoading: false,
        selectedUser: action.payload,
        error: null,
      };

    case ERROR_USER_REQUEST:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default userListReducer;
